"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.set");

var curry = require("../Strict/curry.js");

var go1 = require("../Strict/go1.js");

var pipe = require("../Strict/pipe.js");

var filterL = require("./filterL.js");

module.exports = curry(function uniqueByL(f, iter) {
  const s = new Set();
  return go1(iter, filterL(pipe(f, b => s.has(b) ? false : s.add(b))));
});